import { MessageCircle, Mail, MapPin } from "lucide-react";
import { CLINIC, whatsappLink, DEFAULT_WA_MESSAGE } from "../data/site";

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-white/10 bg-obsidian">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 sm:grid-cols-3 gap-12">
            <div>
                <p className="font-display text-xl text-white">
                    Klinica Dentale <span className="italic text-gold">L'Unite</span>
                </p>
                <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
                    Impiantologia completa a Valona, con volo, hotel e transfer
                    inclusi per i pazienti italiani.
                </p>
            </div>
            <div>
                <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">
                    Contatti
                </p>
                <ul className="space-y-3 text-sm text-white/60">
                    <li>
                        <a
                            href={whatsappLink(DEFAULT_WA_MESSAGE)}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="inline-flex items-center gap-3 hover:text-gold transition-colors duration-300"
                        >
                            <MessageCircle size={15} className="text-gold" />
                            {CLINIC.phoneDisplay}
                        </a>
                    </li>
                    <li>
                        <a
                            href={`mailto:${CLINIC.email}`}
                            data-testid="footer-email-link"
                            className="inline-flex items-center gap-3 hover:text-gold transition-colors duration-300"
                        >
                            <Mail size={15} className="text-gold" />
                            {CLINIC.email}
                        </a>
                    </li>
                    <li className="inline-flex items-center gap-3">
                        <MapPin size={15} className="text-gold" />
                        {CLINIC.city}
                    </li>
                </ul>
            </div>
            <div>
                <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">
                    Privacy
                </p>
                <p className="text-sm text-white/50 leading-relaxed">
                    Questo sito non utilizza cookie di profilazione e non salva
                    dati personali. I messaggi inviati tramite WhatsApp o email
                    sono usati esclusivamente per rispondere alla tua richiesta e
                    non vengono ceduti a terzi.
                </p>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/35">
                <span>© 2026 {CLINIC.name} — {CLINIC.city}</span>
                <span>Preventivo gratuito entro 24 ore</span>
            </div>
        </div>
    </footer>
);
